import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jumpCloud = defineConnector({
  identifier: "jumpCloud",
  name: "JumpCloud",
  tagLine: "Cloud directory platform",
  logo,
  protocol: "http",
  tags: ["it", "security", "identity"],
  defaultUrlPattern: () => "https://console\\.jumpcloud\\.com/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log into the [JumpCloud Admin Portal](https://console.jumpcloud.com/). Click your account name in the bottom left, then select **My API Key**.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "JumpCloud API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://console.jumpcloud.com/api/organizations",
  },
});
